import * as React from 'react';

/** Material UI Packages. */
import { Box, Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid2';

/** Internal Components. */
import { commonResultList, personalResultList } from 'shared/config/constantsData';

/**
 * Component that renders a styled result box with a label-value grid layout.
 * @param {string} title - Section title ("Common Result" or "Personal Result").
 * @param {string[]} labelList - List of label strings.
 * @param {Array} valueList - List of values corresponding to the labels.
 * @param {object} sx - Optional style overrides for the outer Box.
 */
const ResultSection = ({ title, labelList, valueList, sx }) => {
    /**
     * Preprocess the result values:
     * - Round up float numbers.
     * - Replace empty, null, undefined, or 0 with "-".
     */
    const updatedList = valueList.map((value) => {
        if (typeof value === 'number' && !Number.isInteger(value)) {
            return Math.ceil(value);
        }
        if (value === '' || value === 0 || value === null || value === undefined) {
            return '-';
        }
        return value;
    });
    return (
        <Box
            sx={{
                borderRadius: '18px',
                boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.16)',
                p: 2.5,
                mb: 2,
                pb: 0,
                ...sx,
            }}
        >
            <Typography sx={{ color: '#003a52', fontSize: '15px', fontWeight: 500 }}>{title}</Typography>
            <Divider sx={{ mt: 1 }} />
            <Grid container>
                <Grid size={4.5} sx={{ pt: 1.5 }}>
                    {labelList.map((item, idx) => (
                        <Typography key={idx} sx={{ color: 'black', fontSize: 13, fontWeight: 500, mb: 2 }}>
                            {item}
                        </Typography>
                    ))}
                </Grid>
                <Divider orientation="vertical" flexItem />
                <Grid size={6.5} sx={{ pt: 1.5, px: 1.5 }}>
                    {updatedList.map((item, idx) => (
                        <Typography key={idx} sx={{ color: 'black', fontSize: 13, fontWeight: 400, mb: 2 }}>
                            {item || ''}
                        </Typography>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default function ResultCard({ commonResult, personalResult }) {
    /** Extract values from the result objects as arrays. */
    const common_result_values = Object.values(commonResult || {});
    const personal_result_values = Object.values(personalResult || {});

    return (
        <>
            <ResultSection
                title="Common Result"
                labelList={commonResultList}
                valueList={common_result_values}
                sx={{ height: '32%' }}
            />
            <ResultSection
                title="Personal Result"
                labelList={personalResultList}
                valueList={personal_result_values}
                sx={{ height: '44%' }}
            />
        </>
    );
}
